import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { SpinnerButton, GeneralTerms } from 'components';
import { BankId } from 'components/bank-id';
import * as variables from 'frilans-finans/variables';

import {
  requestLogin,
  setError,
  clearError,
  setEntity,
  cancel,
  setAuthType
} from 'redux/modules/bank-id/index';
import LoginBottomElement from './tabs/login-bottom-element';

class LoginWithEidView extends Component {

  static propTypes = {
    switchView: PropTypes.func.isRequired,
    // Redux state
    inProgress: PropTypes.bool,

    // Action creators
    setError: PropTypes.func,
    setAuthType: PropTypes.func,
    setEntity: PropTypes.func,

    // Thunks
    requestLogin: PropTypes.func,
    clearError: PropTypes.func,
    cancel: PropTypes.func
  };

  constructor (props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoadingSameDevice: false
    };

    this.renderBottomElement = this.renderBottomElement.bind(this);
    this.openEIDAuth = this.openEIDAuth.bind(this);
    this.openEIDAuthSameDevice = this.openEIDAuthSameDevice.bind(this);
  }

  componentWillMount () {
    this.props.clearError();
  }

  componentWillUnmount () {
    this.props.setEntity({
      sessionId: null,
      redirectUrl: null,
      autostart: null
    });
    this.props.cancel();
  }

  openEIDAuth () {
    this.setState({
      isLoading: true
    });
    const returnProtocol = variables.appEnv === 'development' ? 'http://' : 'https://';
    const returnUrl = returnProtocol + variables.appUrl + '/eid-link-login';
    const eidAuthUrl = variables.eidUrl + '/start-redirect?return_url=' + returnUrl;
    window.location = eidAuthUrl;
  }

  openEIDAuthSameDevice () {
    this.setState({
      isLoadingSameDevice: true
    });
    const returnProtocol = variables.appEnv === 'development' ? 'http://' : 'https://';
    const returnUrl = returnProtocol + variables.appUrl + '/eid-link-login';
    let eidAuthUrl = variables.eidUrl + '/start-redirect?acr_values=urn:grn:authn:se:bankid:same-device';
    eidAuthUrl += '&return_url=' + returnUrl;
    window.location = eidAuthUrl;
  }

  renderBottomElement () {
    return <LoginBottomElement
      isLogin
      isBankID
      handleClick={this.props.switchView}
    />;
  }

  renderGeneralTerms () {
    return (
      <div>
        <div className="pt-20">
          <GeneralTerms />
        </div>
      </div>
    );
  }

  render () {
    return (
      <div>
        <div
          className='login-input-container eid-buttons'
        >
          <SpinnerButton
            id='login-button'
            text={proxyCounterpart('BANK_ID_ANOTHER_DEVICE')}
            loading={this.state.isLoading}
            classes='btn'
            callback={this.openEIDAuth}
          />
          <SpinnerButton
            id='login-button-same-device'
            text={proxyCounterpart('OPEN_BANK_ID')}
            loading={this.state.isLoadingSameDevice}
            classes='btn'
            callback={this.openEIDAuthSameDevice}
          />
        </div>
        {this.renderBottomElement()}
        <BankId />
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    inProgress: state.bankId.inProgress
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    requestLogin: (socialSecurityNr, createUser) => dispatch(requestLogin(socialSecurityNr, createUser)),
    setError: (error) => dispatch(setError(error)),
    clearError: (force) => dispatch(clearError(force)),
    setEntity: (entity) => dispatch(setEntity(entity)),
    cancel: () => dispatch(cancel()),
    setAuthType: (authType) => dispatch(setAuthType(authType))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginWithEidView);



/** WEBPACK FOOTER **
 ** ./src/views/login-view/login-with-eid-view.js
 **/